// ADR 0003: o web fala com a API só por HTTP, em outra origem. A base vem do
// ambiente de build (ADR 0004 — build estático, sem config em runtime).
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/api'
